import * as tslib_1 from "tslib";
/**
 * 20220303 从纸条管理后台拷贝过来的
 */
import { Component, Vue, Prop, PropSync, Ref } from 'vue-property-decorator';
import E from '@/utils/wangEditor/src/js/index.js';
import ClientRouter from '../clientRouter/index.vue';
import service from "@/api/request";
function randomString(e) {
    e = e || 32;
    let t = "ABCDEFGHJKMNPQRSTWXYZabcdefhijkmnprstwxyz", a = t.length, n = "";
    for (let i = 0; i < e; i++)
        n += t.charAt(Math.floor(Math.random() * a));
    return n;
}
const ICON_LIST = [
    'https://wx-oss.zuowenzhitiao.com/zwzt-image/pic_article_notes_praise.png',
    'https://wx-oss.zuowenzhitiao.com/zwzt-image/pic_article_notes_format.png',
    'https://wx-oss.zuowenzhitiao.com/zwzt-image/pic_article_notes_advise.png'
];
let WangEditor = class WangEditor extends Vue {
    constructor() {
        super(...arguments);
        // 富文本
        this.editor = null;
        this.dialogVisible = false;
        this.fileList = [];
        // 返回接收路由
        this.router = {};
        this.routerLink = '';
        // 是否有图片
        this.hasUploadImg = false;
        this.isShowNotesBox = false;
        this.notes = {
            content: '',
            type: '',
            color: '',
            confrimContent: ''
        };
        this.isShowImport = false;
        this.chooseType = 1;
        this.targetId = '';
        this.isShowWxJump = false;
        this.wxImg = '';
        this.wxid = '';
        this.wxpath = '';
        this.wxids = [];
        this.wxType = 1;
        this.wxPlugin = {
            id: '',
            name: ''
        };
        this.isShowPlugBox = false;
        this.plugList = [];
        this.pageNo = 1;
        this.total = 0;
    }
    mounted() {
        this.editor = new E('#editorElem');
        this.editor.customConfig.onchange = (html) => {
            this.articleSync = html;
        };
        this.editor.customConfig.zIndex = 0;
        this.editor.customConfig.uploadImgMaxSize = 3 * 1024 * 1024; // 将图片大小限制为 3M
        this.editor.customConfig.uploadImgTimeout = 50000;
        // wangEditor必须传递字符串参数，所以重写这个request
        this.editor.customConfig.customUploadImg = (files, insert) => {
            service.postByForm(this.apiUrl, {
                uploadFile: files[0],
                businessType: 'rich',
                fileType: 'richPic'
            }).then(res => {
                insert(res.data.data);
            });
        };
        this.editor.create();
        this.addEventByRouter();
        this.addEventByNotes();
        this.addEventByImportContent();
        this.addEventByWxJump();
        this.getAppId();
    }
    // 初始化内容
    setContent(content) {
        this.editor.txt.html(content);
    }
    // 获取内容
    getContent() {
        return this.replaceTextDecoration(this.editor.txt.html());
    }
    // https://github.com/wangfupeng1988/wangEditor/issues/1405
    // 替换成text-decoration
    replaceTextDecoration(content) {
        return content.replace(/text-decoration-line/g, 'text-decoration');
    }
    addEventByRouter() {
        let routerBtn = document.querySelector('#w-e_link-router');
        if (routerBtn) {
            routerBtn.addEventListener('click', () => {
                this.dialogVisible = true;
            });
        }
    }
    addEventByNotes() {
        let routerBtn = document.querySelector('#w-e_link-notes');
        if (routerBtn) {
            routerBtn.addEventListener('click', () => {
                this.isShowNotesBox = true;
            });
        }
    }
    addEventByImportContent() {
        let routerBtn = document.querySelector('#w-e_link-import');
        if (routerBtn) {
            routerBtn.addEventListener('click', () => {
                this.isShowImport = true;
            });
        }
    }
    addEventByWxJump() {
        let routerBtn = document.querySelector('#w-e_link-wx');
        if (routerBtn) {
            routerBtn.addEventListener('click', () => {
                this.isShowWxJump = true;
            });
        }
    }
    handleCloseImport() {
        this.isShowImport = false;
        this.targetId = '';
        this.chooseType = 1;
    }
    getAppId() {
        // 微信小程序功能隐藏掉了
        // service.getByQuery('/admin/wxMiniProgramConfig/getProgramIds').then(res => {
        // 	const { data } = res.data
        // 	if (data && data.length > 0) {
        // 		let list: any[] = [];
        // 		data.map((item: any) => {
        // 			let data = {
        // 				label: item,
        // 				value: item
        // 			}
        // 			list.push(data);
        // 		})
        // 		this.wxids = list
        // 	}
        // });
    }
    getPlugList() {
        service.getByParams('/courseAdmin/plugin/options', {
            pageNo: this.pageNo
        }).then(res => {
            const { data } = res.data;
            this.plugList = data.list;
            this.pageNo = Number(data.pageNum);
            this.total = Number(data.total);
        });
    }
    onSubmitImport() {
        if (this.targetId === '') {
            this.$message.error('内容ID不可为空');
            return;
        }
        service.getByParams('/courseAdmin/content/manage/getContent', {
            targetId: this.targetId,
            type: this.chooseType
        }).then(res => {
            const { data } = res.data;
            if (this.chooseType === 2) {
                let content = data.content.replace(/\\r/g, '').replace(/\\n/g, '\n');
                let html = '';
                content.split('\n').map((item) => {
                    html += `<p>${item}</p>`;
                });
                this.editor.cmd.do('insertHTML', html);
            }
            else {
                this.editor.cmd.do('insertHTML', data.content);
            }
            this.isShowImport = false;
            this.targetId = '';
            this.chooseType = 1;
        });
    }
    handleCloseNotes() {
        this.notes.content = '';
        this.notes.confrimContent = '';
        this.notes.type = '';
        this.notes.color = '';
        this.isShowNotesBox = false;
    }
    onSubmitNotes() {
        if (this.notes.content === '') {
            this.$message.error('被注释内容不可为空');
            return;
        }
        if (this.notes.type === '') {
            this.$message.error('注释类型不可为空');
            return;
        }
        if (this.notes.type.length < 4 || this.notes.type.length > 8) {
            this.$message.error('注释类型长度在4-8个字符之间');
            return;
        }
        if (this.notes.color === '') {
            this.$message.error('标注颜色不可为空');
            return;
        }
        if (this.notes.confrimContent === '') {
            this.$message.error('注释内容不可为空');
            return;
        }
        const isSeleEmpty = this.editor.selection.isSelectionEmpty();
        if (isSeleEmpty) {
            // 选区是空的，插入并选中一个“空白”
            this.editor.selection.createEmptyRange();
        }
        let id = randomString(6);
        if (this.editor.selection.getRange().commonAncestorContainer.innerHTML == undefined) {
            let html = `<i id="${id}" style="background:rgba(0,0,0,0.08)"><span>${this.notes.content}</span><img class="TextRemarks" data-notesid="${id}" data-notetype="${this.notes.type}" data-color="${this.notes.color}" data-content="${encodeURIComponent(this.notes.confrimContent)}" src="${ICON_LIST[this.notes.color - 1]}" /></i> `;
            this.editor.cmd.do('insertHTML', html);
        }
        else {
            let html = `<i id="${id}" style="background:rgba(0,0,0,0.08)">${this.notes.content}<img class="TextRemarks" data-notesid="${id}" data-notetype="${this.notes.type}" data-color="${this.notes.color}" data-content="${encodeURIComponent(this.notes.confrimContent)}" src="${ICON_LIST[this.notes.color - 1]}" /></i> `;
            this.editor.cmd.do('insertHTML', html);
        }
        if (isSeleEmpty) {
            // 需要将选取折叠起来
            this.editor.selection.collapseRange();
            this.editor.selection.restoreSelection();
        }
        this.handleCloseNotes();
    }
    handleClose() {
        this.dialogVisible = false;
        this.fileList = [];
    }
    submitRouter() {
        this._clientRouter
            .getCurrentSelect()
            .then((res) => {
            this.router = res.router;
            this.routerLink = res.routerLink;
            if (!this.hasUploadImg) {
                throw '请上传路由图片';
            }
            else {
                this._uploader.submit();
            }
        })
            .catch((msg) => this.$alert(msg));
    }
    // 成功上传图片后提交
    upload(res) {
        // 因为富文本内容是长久保存的
        // 所以路由需要两边动态设置，不能完全写死
        let { params } = this.router;
        let link = this.routerLink;
        // 注意params传递对象时 单双引号区别
        this.editor.cmd.do('insertHTML', `
      <img class="router-by_img" style="width: 100%;" model="${this.router.isModelEssay}" link="${link}" params='${JSON.stringify(params)}' src="${res.data}">
    `);
        // 将变量重置
        this.hasUploadImg = false;
        this.handleClose();
    }
    changeUpload(file, fileList) {
        this.hasUploadImg = true;
    }
    removeUpload() {
        this.hasUploadImg = false;
    }
    handleCloseWxJump() {
        this.isShowWxJump = false;
        this.wxImg = '';
        this.wxid = '';
        this.wxpath = '';
        this.wxType = 1;
        this.wxPlugin = {
            id: '',
            name: ''
        };
    }
    onWxJumpSuccess(res) {
        if (res.status === 200) {
            this.wxImg = res.data;
        }
        else {
            this.$message.error(res.msg);
        }
    }
    openWxPlugBox() {
        this.getPlugList();
        this.isShowPlugBox = true;
    }
    handClosePlugBox() {
        this.isShowPlugBox = false;
        this.plugList = [];
        this.pageNo = 1;
        this.total = 0;
    }
    onChoosePlug(props) {
        this.wxPlugin.id = props.id;
        this.wxPlugin.name = props.name;
        this.handClosePlugBox();
    }
    changePage(pageNo) {
        this.pageNo = pageNo;
        this.getPlugList();
    }
    submitWxJump() {
        if (this.wxImg === '') {
            this.$message.error('请上传图片');
            return;
        }
        if (this.wxid === '') {
            this.$message.error('请输入小程序ID');
            return;
        }
        if (this.wxType === 1 && this.wxPlugin.id === '') {
            this.$message.error('请选择插件');
            return;
        }
        let url = this.wxType === 1 ? `pages/contact/index?id=${this.wxPlugin.id}&source=zhitiao` : this.wxpath;
        this.editor.cmd.do('insertHTML', `<img class="wxJump-by_img" style="width: 100%;" data-id="${this.wxid}" data-path="${url}"  src="${this.wxImg}">`);
        // this.editor.cmd.do(
        // 	'insertHTML',
        // 	`<img class="wxJump-by_img" style="width: 100%;" data-id="gh_d48c22e934c1" data-path=""  src="${this.wxImg}">`
        // );
        this.handleCloseWxJump();
    }
};
tslib_1.__decorate([
    PropSync('article', String)
], WangEditor.prototype, "articleSync", void 0);
tslib_1.__decorate([
    Prop({ type: String, default: '/courseAdmin/file/uploadFile' })
], WangEditor.prototype, "apiUrl", void 0);
tslib_1.__decorate([
    Ref()
], WangEditor.prototype, "_uploader", void 0);
tslib_1.__decorate([
    Ref()
], WangEditor.prototype, "_clientRouter", void 0);
WangEditor = tslib_1.__decorate([
    Component({
        components: {
            ClientRouter,
        },
    })
], WangEditor);
export default WangEditor;
